function e(e){return e.filter(e=>{const r=e.code.toLowerCase();return r.includes("mask")&&r.includes("raw")})}export{e as default};
